import { Box, Flex, FormControl, FormErrorMessage, Stack } from '@chakra-ui/react';
import Button from '@components/interactive/Button';
import TextInput from '@components/interactive/TextInput';
import DefaultLayout from '@components/layout/layout/DefaultLayout';
import { sendToken } from '@components/login/requests';
import Body1 from '@components/typography/Body1';
import Header from '@components/typography/Header';
import { Routes } from '@constants/routes';
import { textInputHeight } from '@constants/styles';
import { useAuthenticatedContextProvider } from '@contexts/AuthenticatedContextProvider';
import { validateEmail } from '@utils/validateEmail';
import { Field, Form, Formik } from 'formik';
import router from 'next/router';

const Login = () => {
  const { localUser, setLocalUser } = useAuthenticatedContextProvider();
  const { phone } = router.query;

  const handleSubmit = async ({ email }, { resetForm }) => {
    resetForm();
    // Only update user data if not already authenticated
    if (!localUser?.token) {
      setLocalUser({ ...localUser, email });
    }
    await sendToken(email, phone as string);
    router.push(Routes.checkEmail);
  };

  return (
    <DefaultLayout>
      <Stack
        border="10px solid"
        borderColor="teal"
        px={[10, 10, 10, 100]}
        pt={['80px', '120px', '120px', 160]}
        pb={['100px', '240px', '240px', 240]}
        bg="white"
        spacing={6}
        alignItems="center"
      >
        <Header as="h2">Login</Header>
        <Body1 textAlign="center">We'll send a secure login link to your email.</Body1>
        <Flex>
          <Formik initialValues={{ email: '' }} onSubmit={handleSubmit}>
            {({ isSubmitting }) => (
              <Form>
                <Stack alignItems="center" spacing={6}>
                  <Field name="email" type="email" validate={validateEmail}>
                    {({ field, form }) => (
                      <FormControl
                        isInvalid={form.errors.email && form.touched.email && field.value.length > 4}
                        w="300px"
                        h={textInputHeight}
                      >
                        <TextInput
                          field={field}
                          id="email-input"
                          name="email"
                          type="email"
                          placeholder="Email Address"
                          autoComplete="email"
                        />
                        <FormErrorMessage>{form.errors.email}</FormErrorMessage>
                      </FormControl>
                    )}
                  </Field>
                  <Box>
                    <Button whiteSpace="nowrap" type="submit" isLoading={isSubmitting}>
                      Send Link
                    </Button>
                  </Box>
                </Stack>
              </Form>
            )}
          </Formik>
        </Flex>
      </Stack>
    </DefaultLayout>
  );
};

export default Login;
